<template>
	<div class="container-fluid px-lg-2 px-xl-4">
		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Carrito</li>
					</ol>
				</nav>
			</div>
		</div>

		<div>
			<!-- Impuestos -->
			<div class="row d-flex align-items-center bg-white justify-content-center mb-2 py-2">
				<div class="col-12 col-md-6 col-xl-8 d-flex vertical-align-center">
					<span class="impuestos-texto mr-2">Productos con:</span>
					<span class="impuestos-iva mt-1 mr-1">&nbsp;</span>
					<span class="impuestos-texto">IVA</span>
					<span class="impuestos-texto d-none d-xl-block">(Impuestos sobre el valor agregado)</span>
					<span class="impuestos-ieps mt-1 mr-1 ml-3">&nbsp;</span>
					<span class="impuestos-texto">IEPS</span>
					<span class="impuestos-texto d-none d-xl-block">(Impuesto Especial sobre Producci&oacute;n y Servicios)</span>
					<!-- <pm-button-excel :rutaCargado="rutaCargado" @togleMenu=redirect></pm-button-excel> -->
				</div>
				<div class="col-12 col-md-6 col-xl-4 d-none d-md-block text-right">
					<span class="saldo-texto mr-2">Saldo total:</span>
					<span class="saldo-monto">{{totalEncabezado | format-number("$0,0.00")}}</span>
				</div>
			</div>

			<div class="row d-block d-md-none bg-white mb-2">
				<div class="col-12 text-right">
					<span class="saldo-texto">Saldo total:</span>
					<span class="saldo-monto">{{totalEncabezado | format-number("$0,0.00")}}</span>
				</div>
			</div>			
		</div>	

		<pm-tabla-carrito @total=total
						@actualizarTotalCarrito="actualizarTotalCarrito"
						@togleMenu=togleMenu></pm-tabla-carrito>
	</div>
</template>
<script>
	// import PmButtonExcel from "@/components/clientes/ButtonExcel"
	import PmTablaCarrito from "@/components/clientes/TablaCarrito"
	
	export default {
		data() {
			return {
				totalEncabezado: 0,
				// rutaCargado: 'carrito'
			}
		},
		components: {
			// PmButtonExcel,
			PmTablaCarrito,
		},
		mounted() {
			const especial = this.$route.query.especial
			console.log(especial)

			this.carritoConsultarCantidad()
			this.obtenerNotificaciones()
		},
		computed: {
		},
		methods: {
			total(Total){
				this.totalEncabezado = Total
			},
			togleMenu(opcion){
				this.$emit("togleMenu", opcion);
			},
			actualizarTotalCarrito(){
				this.carritoConsultarCantidad()
			}
		},
	}
</script>
<style scoped>
	.impuestos-texto {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.impuestos-iva {
		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: #ff8800 !important;
		justify-content: center;
		align-items: center;
		text-align: center;
	}
	.impuestos-ieps {
		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: #0088ff !important;
		justify-content: center;
		align-items: center;
		text-align: center;
	}
	.saldo-texto {
		font-family: "Open Sans";
		font-weight: 700;
		color: var(--bg-menu-blue);
	}
	.saldo-monto {
		font-family: "Open Sans";
		font-weight: 600;
		color: var(--bg-menu-blue);
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
	}
</style>